import { usePrimaryControlsStripBackResolution } from "#use-primary-controls-strip-back-resolution";

/**
 * Whether the resolved back control is "wide" — i.e. it renders a label beside the chevron rather
 * than the bare chevron or nothing. `PrimaryControlsStrip` uses this to allocate header width: with a wide
 * back control the title stays in an equal-thirds centered column so a long back label and the
 * title share the row symmetrically; with only the chevron (the common case, e.g. an unlabeled
 * stack back) the left column collapses to its content and the title takes the freed space
 * instead of being squeezed into a third and shrunk by `adjustsFontSizeToFit`.
 *
 * Derived from the same resolution as visibility, so a control can never be reported wide while
 * the host declines to draw it. Always false on web.
 */
export function usePrimaryControlsStripHasWideBackControl(): boolean {
  return usePrimaryControlsStripBackResolution().isWide;
}
